import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SetupReviewModelComponent } from './setup-review-model/setup-review-model.component';
import { UserService } from 'src/app/services/user.service';
import { ReviewService } from 'src/app/services/common/review.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import * as _ from 'lodash';
import { EAP_APP, GM_APP, IST_APP } from 'src/app/models/common';
import { CompleteReviewComponent } from '../my-reviews/complete-review/complete-review.component';

@Component({
  selector: 'app-schedule-review',
  templateUrl: './schedule-review.component.html',
  styleUrls: ['./schedule-review.component.scss']
})
export class ScheduleReviewComponent  implements OnInit {
  @Input() public Content: any;
  content: any;
  appId: any;
  appCode: any;
  reviews: any;
  ModuleID: any;
  SubModule: any;
  ApplicationID: any; 
  OptionValues:any=[];
  appStatus: any;
  istapp: IST_APP;
  eapapp: EAP_APP;
  grantsapp: GM_APP;
  ApplicationCode: any;
  ApplicationStatus: any;
  module: any;
  owner: string;
  coOwner: string;
  user: any;
  hasChangeOwnerPrevilage: boolean = false;
  IsCoowner: boolean = false;

  constructor(private modalService: NgbModal, 
    private reviewService: ReviewService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    public modalRef: NgbActiveModal,
    private userService: UserService,
    private ngbModal: NgbModal,   
    ){}
  
  ngOnInit(){
    this.istapp = this.commonService.getISTApp();
    this.eapapp = this.commonService.getEAPApp();
    this.grantsapp = this.commonService.getGrantsApp();
    this.module = this.commonService.getModuleName();
    this.user = this.userService.getUserDetais();
    
    switch(this.module.toLowerCase())
    {
         case "ist":
          this.ApplicationID = this.istapp.ID;
          this.ApplicationCode =this.istapp.APPLICATION_CODE;
          this.ApplicationStatus = this.istapp.STATUS;
          this.owner = this.istapp.CREATED_BY;
          this.coOwner = this.istapp['COOWNER'];
          
          break;
          case "eap":
            this.ApplicationID = this.eapapp.ID;
            this.ApplicationCode =this.eapapp.APPLICATION_CODE;
            this.ApplicationStatus = this.eapapp.STATUS;
            this.owner = this.eapapp.CREATED_BY;
            this.coOwner = this.eapapp['COOWNER'];
          break;
          case "grants":
          case "grantssponsorship":
          case "grantscme":
          case "grantscharitable":
            this.ApplicationID = this.grantsapp.ID;
            this.ApplicationCode =this.grantsapp.APPLICATION_CODE;
            this.ApplicationStatus = this.grantsapp.STATUS;
            this.owner = this.grantsapp.CREATED_BY;
            this.coOwner = this.grantsapp['COOWNER'];
          break;
    }

    this.appId = this.ApplicationID;
    this.appCode = this.ApplicationCode;
    this.appStatus = this.ApplicationStatus;

    this.GetReviews();
    this.GetApplicationDetails();

    if(this.owner != this.user.ID && this.coOwner != this.user.ID){
      this.GetChangeOwnPr();
    }

    if(this.coOwner == this.user.ID){
      this.IsCoowner = true;
    }

  }

  GetReviews() {
    this.reviewService.GetReviews("api/Review/GetReviews?ApplicationID=" + this.appId).subscribe((result: any[] )=> {
      if (result) {
       let closedRev = result.filter(x=> x.ReviewStatus == 3 || x.ReviewStatus == 4 || x.ReviewStatus == 5);
       if(closedRev != undefined || closedRev.length > 0){
        this.reviews = closedRev; 
       }

       let unclosedRev =  result.filter(x=> x.ReviewStatus != 3 && x.ReviewStatus != 4 && x.ReviewStatus != 5);

       if(unclosedRev != undefined || unclosedRev.length > 0){
        this.OptionValues = unclosedRev;
       }
      }
    });
  }

  GetChangeOwnPr() {
    this.reviewService.GetChangeOwnPr("api/Review/GetChangeOwnPr?Module=" + this.ModuleID).subscribe((result: any)=> {
      if (result) {
        this.hasChangeOwnerPrevilage = result;
      }
    });
  }

  GetApplicationDetails(){
    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {   
        this.ModuleID = this.commonService.getModuleId(params['module']);
        this.ApplicationID = this.commonService.appId;//params['id'];
        this.SubModule = params['submodule'];
      }
    });
  }

  setup(){
    let modalRef = this.modalService.open(SetupReviewModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: { applicationId: this.appId, applicationCode: this.appCode, applicationStatus: this.appStatus,module: this.ModuleID,subModule: this.SubModule }
    }
    modalRef.result.then(result => {    
      this.GetReviews();   
    });
  } 

  ValidateUserPrev(Review: any){
    let HasPrev: boolean = false;
    if(!Review.HasReviewPrevilage){
      HasPrev = true;
    }
    return HasPrev;
  }

  EditReview(Review: any) {
      let modalRef = this.modalService.open(SetupReviewModelComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content = {
        heading: 'Edit',
        content: { ReviewId: Review.ID, applicationId: this.appId, applicationCode: this.appCode,module: this.ModuleID,subModule: this.SubModule }
      }
      modalRef.result.then(result => {
        this.GetReviews();
      });    
  } 
  
  ViewReview(Review:any){
    let modalRef = this.modalService.open(SetupReviewModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'View',
      content: { ReviewId:Review.ID, applicationId: this.appId, applicationCode: this.appCode,module: this.ModuleID,subModule: this.SubModule }
    }
    modalRef.result.then(result => {    
      this.GetReviews();   
    });
  } 

  Changeowner_Review(Review:any){
    let modalRef = this.modalService.open(SetupReviewModelComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content: { ReviewId:Review.ID,IsChangeOwner:true, applicationId: this.appId, applicationCode: this.appCode,module: this.ModuleID,subModule: this.SubModule }
    }
    modalRef.result.then(result => {    
      this.GetReviews();   
    });
  } 

  StartReview(Review:any){  

    let formData = { "ID":Review.ID ,"MODULE_ID":this.ModuleID ,"Application_Code":this.appCode
    ,"GrantType":this.SubModule };

    this.reviewService.StartReview("api/Review/StartReview?Id=" + Review.ID + "&AppCode=" + this.appCode).subscribe(result => {
      if (result.Status == 0) {       
          this.commonService.SuccessBanner(result.Message);
          this.GetReviews();  
      }
      else{
        this.commonService.ValidationBanner(result.Message);
      }    
    });
  }

   

  DeleteReviewConf(Review:any) {    
    const modalRef = this.modalService.open(DeleteBoxComponent, {backdrop: false
  })   
  modalRef.componentInstance.Content={ heading: 'Confirmation', custommessage: 'Do you really want to delete the selected review?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" }
    modalRef.result.then((result) => {
      if(result=="okclick")
      {        
        this.DeleteReview(Review); 
        this.modalRef.close();    
      }
    });
  }

  DeleteReview = (Review:any) => {
    let formData = { "ID":Review.ID ,"MODULE_ID":this.ModuleID ,"Application_Code":this.appCode
    ,"GrantType":this.SubModule };
    this.reviewService.DeleteReview("api/Review/DeleteReview?Id=" + Review.ID + "&AppCode=" + this.appCode).subscribe(result => {
      if (result.Status == 0) {    
       this.commonService.SuccessBanner(result.Message);
       this.modalRef.close();
       this.GetReviews();  
        } else {        
        this.commonService.ValidationBanner(result.Message);      
      }
    });
  }

  CancelReview(Review:any){
    let formData = { "ID":Review.ID ,"MODULE_ID":this.ModuleID ,"Application_Code":this.appCode
    ,"GrantType":this.SubModule, "Application_ID": this.ApplicationID };
    this.reviewService.CancelReview("api/Review/CancelReview?Id=" + Review.ID + "&AppCode=" + this.appCode).subscribe(result => {
      if (result.Status == 0) {       
          this.commonService.SuccessBanner(result.Message);
          this.GetReviews();  
      }
      else{
        this.commonService.ValidationBanner(result.Message);
      }    
    });
  }

  CloseReview(Review:any){ 
      let modalRef = this.modalService.open(CompleteReviewComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg modal-right',
        animation: true
      });
      modalRef.componentInstance.Content= {
        heading: 'Task Completion',
        content: { ReviewId:Review.ID,applicationCode: this.appCode,TaskType: "Review",Title: Review.Title }
      }
      modalRef.result.then(result => {    
        this.GetReviews();  
      });     
  }

  close() {   
    this.modalService.dismissAll();   
  }

  
  moveInArray(arr, fromIndex, toIndex) {   
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  MovePostion(naviType, element) {
    let fromIndex = this.OptionValues.indexOf(element);
    let first = this.OptionValues[0].strReviewStatus != "Pending";
    if (naviType == "down") {
      let toIndex = fromIndex + 1;
      if(fromIndex == 0 && first){        
      } else{
        this.moveInArray(this.OptionValues, fromIndex, toIndex);
      }
    }
    else {
      let toIndex = fromIndex - 1;
      if (first && toIndex == 0) {        
      } else{
        this.moveInArray(this.OptionValues, fromIndex, toIndex);
      }
    }

    this.saveOrder(this.OptionValues);
  }

  selectedRev(event: any, rev: any): void {
    let isChecked: boolean = event.target.checked;
    rev.IsSelected = isChecked;
    rev.AutoStart = isChecked;   
    this.saveOrder(this.OptionValues);
  }

  saveOrder(reviews: any){
    this.reviewService.updateOrder("api/Review/UpdateOrder", reviews).subscribe(result => {
      if (result.Status == 0) {       
          //this.commonService.SuccessBanner(result.Message);
          this.GetReviews();  
      }
      else{
        this.commonService.ValidationBanner(result.Message);
      }    
    });
  }
}
